<i mui-icon
   class='mui-icon-toggle-button__icon'
   [name]='iconName'
   [font]='iconFont'></i>
